import { render, staticRenderFns } from "./SyncAlertsTab.vue?vue&type=template&id=4c03d474&scoped=true";
import script from "./SyncAlertsTab.vue?vue&type=script&lang=js";
export * from "./SyncAlertsTab.vue?vue&type=script&lang=js";
import style0 from "./SyncAlertsTab.vue?vue&type=style&index=0&id=4c03d474&prod&scoped=true&lang=less";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "4c03d474", null);
export default component.exports;